// src/app/store/asistencia/asistencia.reducer.ts
import {
  AsistenciaActions,
  AsistenciaActionTypes,
  AsistenciaState,
} from './asistencia.actions';

// 🔥 ESTADO INICIAL MEJORADO Y CENTRALIZADO
export const initialAsistenciaState: AsistenciaState = {
  // Estados de actividades en tiempo real
  breakActivo: false,
  banoActivo: false,
  totalBreaks: 0,
  totalBanos: 0,
  puedeTomarBreak: true,
  puedeIrAlBano: true,
  horaSalida: null,

  // Tiempos específicos para contadores
  tiempoBreakActual: 0,
  tiempoBanoActual: 0,
  breakExcedido: false,
  banoExcedido: false,

  // 🔥 NUEVO: Tiempos en segundos para cálculos más precisos
  banoTiempoActualSegundos: 0,
  breakTiempoActualSegundos: 0,

  // Datos de tiempo (pueden ser calculados o venir de un selector)
  tiempoTrabajado: '00:00:00',
  tiempoDescansos: '00:00',
  porcentajeJornada: 0,

  // Estados de la aplicación
  loading: false,
  loadingBreak: false,
  loadingBano: false,
  loadingSalida: false,
  loadingAsistencia: false, // 🔥 NUEVO: Loading para iniciar asistencia
  yaRegistroEntrada: false, // 🔥 NUEVO: Si ya registró entrada hoy
  yaMarcoSalida: false, // 🔥 NUEVO: Si ya marcó salida hoy
  error: null,

  // Datos de listas
  asistenciasHoy: [],
  asistenciasAsesorOptimizadas: [],

  // Metadatos
  lastUpdated: null,
  sincronizado: true,
};

// 🔥 REDUCER REFACTORIZADO Y COMPLETO
export function asistenciaReducer(
  state = initialAsistenciaState,
  action: AsistenciaActions
): AsistenciaState {
  switch (action.type) {
    // 🔥 CASO PRINCIPAL: Actualizar estado desde el backend
    case AsistenciaActionTypes.VERIFICAR_ESTADO_ACTIVIDADES_SUCCESS:
      const newState = {
        ...state,

        // 🔥 MAPEO CORREGIDO según la respuesta real del backend
        banoActivo: action.payload.banoActivo || false,
        breakActivo: action.payload.breakActivo || false,
        puedeIrAlBano: action.payload.puedeIrAlBano !== false,
        puedeTomarBreak: action.payload.puedeTomarBreak !== false,
        totalBanos: action.payload.totalBanos || 0,
        totalBreaks: action.payload.totalBreaks || 0,
        horaSalida: action.payload.horaSalida || null,

        // Tiempos actuales (usando las claves que realmente envía el backend)
        tiempoBanoActual: action.payload.banoTiempoActual || 0,
        tiempoBreakActual: action.payload.breakTiempoActual || 0,
        banoExcedido: action.payload.banoExcedido || false,
        breakExcedido: action.payload.breakExcedido || false,

        // Estados de entrada/salida del backend
        yaRegistroEntrada: action.payload.yaRegistroEntrada || false,
        yaMarcoSalida: action.payload.yaMarcoSalida || false,

        // Metadata
        loading: false,
        loadingBreak: false,
        loadingBano: false,
        loadingSalida: false,
        lastUpdated: new Date(),
        sincronizado: true,
        error: null,
      };
    
      return newState;

    // ========================================
    // 🔥 MANEJO DE DATOS PARA EL CALENDARIO
    // ========================================
    case AsistenciaActionTypes.LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO_SUCCESS:
      return {
        ...state,
        asistenciasAsesorOptimizadas: action.payload, // Solo actualiza esta propiedad
        loading: false, // Detiene el loading general si estaba activo
        lastUpdated: new Date(),
        error: null,
      };

    // ========================================
    // 🔥 MANEJO DE ESTADOS DE CARGA (LOADING)
    // ========================================
    case AsistenciaActionTypes.VERIFICAR_ESTADO_ACTIVIDADES:
    case AsistenciaActionTypes.LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO:
      return { ...state, loading: true, error: null };

    // 🔥 NUEVO: Iniciar asistencia
    case AsistenciaActionTypes.INICIAR_ASISTENCIA:
      return { ...state, loadingAsistencia: true, error: null };

    case AsistenciaActionTypes.MARCAR_SALIDA:
      return { ...state, loadingSalida: true, error: null };

    case AsistenciaActionTypes.INICIAR_BREAK:
    case AsistenciaActionTypes.FINALIZAR_BREAK:
      return { ...state, loadingBreak: true, error: null };

    case AsistenciaActionTypes.INICIAR_BANO:
    case AsistenciaActionTypes.FINALIZAR_BANO:
      return { ...state, loadingBano: true, error: null };

    // ========================================
    // 🔥 MANEJO DE ACCIONES DE ÉXITO
    // ========================================
    case AsistenciaActionTypes.INICIAR_BREAK_SUCCESS:
    case AsistenciaActionTypes.FINALIZAR_BREAK_SUCCESS:
      return { ...state, loadingBreak: false };

    case AsistenciaActionTypes.INICIAR_BANO_SUCCESS:
    case AsistenciaActionTypes.FINALIZAR_BANO_SUCCESS:
      return { ...state, loadingBano: false };

    case AsistenciaActionTypes.INICIAR_ASISTENCIA_SUCCESS:
      return {
        ...state,
        loadingAsistencia: false,
        yaRegistroEntrada: true, // 🔥 NUEVO: Marcar que ya registró entrada
      };

    case AsistenciaActionTypes.MARCAR_SALIDA_SUCCESS:
      return {
        ...state,
        loadingSalida: false,
        yaMarcoSalida: true, // 🔥 NUEVO: Marcar que ya registró salida
      };

    // ========================================
    // 🔥 MANEJO DE ERRORES
    // ========================================
    case AsistenciaActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loadingBreak: false,
        loadingBano: false,
      };

    case AsistenciaActionTypes.INICIAR_BREAK_FAILURE:
    case AsistenciaActionTypes.FINALIZAR_BREAK_FAILURE:
      return { ...state, loadingBreak: false, error: action.payload };

    case AsistenciaActionTypes.INICIAR_BANO_FAILURE:
    case AsistenciaActionTypes.FINALIZAR_BANO_FAILURE:
      return { ...state, loadingBano: false, error: action.payload };

    case AsistenciaActionTypes.INICIAR_ASISTENCIA_FAILURE:
      return { ...state, loadingAsistencia: false, error: action.payload };

    case AsistenciaActionTypes.MARCAR_SALIDA_FAILURE:
      return { ...state, loadingSalida: false, error: action.payload };

    // 🔥 CASO ADICIONAL: Actualizar estado completo
    case AsistenciaActionTypes.UPDATE_ESTADO_COMPLETO:
      return {
        ...state,
        breakActivo: action.payload.breakActivo,
        banoActivo: action.payload.banoActivo,
        totalBreaks: action.payload.totalBreaks,
        totalBanos: action.payload.totalBanos,
        puedeTomarBreak: action.payload.puedeTomarBreak,
        puedeIrAlBano: action.payload.puedeIrAlBano,
        yaMarcoSalida: !!action.payload.horaSalida,
      };

    // ========================================
    // 🔥 OTRAS ACCIONES (RESET, ETC.)
    // ========================================
    case AsistenciaActionTypes.RESET_ESTADO:
      return { ...initialAsistenciaState };

    default:
      return state;
  }
}

// ========================================
// 🔥 SELECTORES (SIN CAMBIOS)
// ========================================
export const getAsistenciaState = (state: any): AsistenciaState => {
  const asistenciaState = state.asistencia || initialAsistenciaState;
  if (!state.asistencia) {
    console.warn('⚠️ getAsistenciaState: state.asistencia es undefined, usando initialAsistenciaState');
    console.log('🔍 Estado completo:', state);
  }
  return asistenciaState;
};
export const getBreakActivo = (state: any): boolean =>
  getAsistenciaState(state).breakActivo;
export const getBanoActivo = (state: any): boolean =>
  getAsistenciaState(state).banoActivo;
export const getTotalBreaks = (state: any): number =>
  getAsistenciaState(state).totalBreaks;
export const getTotalBanos = (state: any): number =>
  getAsistenciaState(state).totalBanos;
export const getPuedeTomarBreak = (state: any): boolean =>
  getAsistenciaState(state).puedeTomarBreak;
export const getPuedeIrAlBano = (state: any): boolean =>
  getAsistenciaState(state).puedeIrAlBano;
export const getHoraSalida = (state: any): string | null =>
  getAsistenciaState(state).horaSalida;
export const getTiempoBreakActual = (state: any): number =>
  getAsistenciaState(state).tiempoBreakActual;
export const getTiempoBanoActual = (state: any): number =>
  getAsistenciaState(state).tiempoBanoActual;
export const getBreakExcedido = (state: any): boolean =>
  getAsistenciaState(state).breakExcedido;
export const getBanoExcedido = (state: any): boolean =>
  getAsistenciaState(state).banoExcedido;
export const getAsistenciaLoading = (state: any): boolean =>
  getAsistenciaState(state).loading;
export const getBreakLoading = (state: any): boolean =>
  getAsistenciaState(state).loadingBreak;
export const getBanoLoading = (state: any): boolean =>
  getAsistenciaState(state).loadingBano;
export const getSalidaLoading = (state: any): boolean =>
  getAsistenciaState(state).loadingSalida;
export const getAsistenciaError = (state: any): string | null =>
  getAsistenciaState(state).error;
export const getAsistenciasAsesorOptimizadas = (state: any): any[] =>
  getAsistenciaState(state).asistenciasAsesorOptimizadas || [];

// 🔥 NUEVO: Selector para loading de iniciar asistencia
export const getIniciarAsistenciaLoading = (state: any): boolean =>
  getAsistenciaState(state).loadingAsistencia || false;

export const getEstadoCompleto = (state: any) => {
  const s = getAsistenciaState(state);
  return {
    breakActivo: s.breakActivo,
    banoActivo: s.banoActivo,
    totalBreaks: s.totalBreaks,
    totalBanos: s.totalBanos,
    puedeTomarBreak: s.puedeTomarBreak,
    puedeIrAlBano: s.puedeIrAlBano,
    horaSalida: s.horaSalida,
    tiempoBreakActual: s.tiempoBreakActual,
    tiempoBanoActual: s.tiempoBanoActual,
    breakExcedido: s.breakExcedido,
    banoExcedido: s.banoExcedido,
    yaRegistroEntrada: s.yaRegistroEntrada, // 🔥 NUEVO: Incluir estado de entrada
    yaMarcoSalida: s.yaMarcoSalida, // 🔥 NUEVO: Incluir estado de salida
  };
};